import { gql } from '@apollo/client';

const GET_MARKETS = gql`
query GetMarkets {
  markets(first: 60) {
    nodes {
      slug
      title
      regiones {
        nodes {
          slug
          name
        }
      }
      marketDetails {
        thumbnail {
          node {
            mediaItemUrl
            title
          }
        }
        nombres {
          es
          en
          pt
        }
        showDetailLink
      }
    }
  }
}`;

const GET_MARKET_PAYMENT_METHODS = gql`
query GetMarketPaymentMethods($slug: String!) {
  marketBy(slug: $slug) {
    slug
    cardPaymentMethods(first:100) {
      nodes {
        paymentMethodDetails {
          logo {
            node {
              mediaItemUrl
            }
          }
        }
        name
      }
    }
    cashPaymentMethods(first:100) {
      nodes {
        paymentMethodDetails {
          logo {
            node {
              mediaItemUrl
              title
            }
          }
        }
        name
      }
    }
    eWalletsPaymentMethods(first:100) {
      nodes {
        paymentMethodDetails {
          logo {
            node {
              mediaItemUrl
              title
            }
          }
        }
        name
      }
    }
    mobilePaymentMethods(first:100) {
      nodes {
        paymentMethodDetails {
          logo {
            node {
              mediaItemUrl
              title
            }
          }
        }
        name
      }
    }
    onlinePaymentMethods(first:100) {
      nodes {
        paymentMethodDetails {
          logo {
            node {
              mediaItemUrl
              title
            }
          }
        }
        name
      }
    }
  }
}`;


export { GET_MARKETS, GET_MARKET_PAYMENT_METHODS };